/*
 * The texts of the user location extension, merged into the lib's own through its js/extension.ts.
 */
export default {
	buttons: {
		header: {
			location: 'Standort',
		},
	},
	components: {
		header_location: {
			enable: 'Aktivieren',
			disable: 'Deaktivieren',
			force_update: 'Standort jetzt aktualisieren',
		},
	},
};
